
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"14","height":"12","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.884.969a.4.4 0 01-.002.565l-9.6 9.5a.4.4 0 01-.56.003l-3.6-3.5a.4.4 0 11.557-.574l3.319 3.227 9.32-9.224a.4.4 0 01.566.003z"}})])
      }
    
      }
    